export const replaceSlash = (value) => {
  if (value) {
    if (value[0] === '/') {
      return value.substr(1, value.length);
    } else {
      return value;
    }
  }
}